"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 20 20" id=icon-heart-filled-20><path d="M8.1 1.719c.608.387 1.218.95 1.9 1.723.682-.772 1.292-1.336 1.9-1.723.885-.563 1.708-.719 2.6-.719 1.81 0 3.217.767 4.151 1.918C19.566 4.045 20 5.5 20 6.888c0 2.529-1.744 4.271-2.27 4.796l-7.023 7.023a1 1 0 0 1-1.414 0L2.27 11.684C1.744 11.16 0 9.417 0 6.89 0 5.5.434 4.046 1.349 2.92 2.283 1.766 3.69 1 5.5 1c.892 0 1.715.156 2.6.719Z"></path></symbol>';
}
